import { TableSettings } from '../types/types/table';
import getStorageItem from '../helpers/getStorageItem';
import { getSettingsOrDefault } from '../utils/localStorageUtils';

function useLocalStorage(settingsKey: string, defaultSettings: TableSettings) {
  function setSettingsOrDefault() {
    const currentLocalStorageSettings =
      getStorageItem<TableSettings>(settingsKey);

    return getSettingsOrDefault(
      settingsKey,
      currentLocalStorageSettings,
      defaultSettings,
    );
  }

  return {
    settings: setSettingsOrDefault(),
  };
}

export default useLocalStorage;
